import { ClientBoardsCacheService as Cache } from "./cache";
import type {
  tMutationClientAddedArgs,
  tMutationClientMovedArgs,
  tMutationClientRemovedArgs,
  tMutationListCreatedArgs,
  tMutationListMovedArgs,
  tMutationListRemovedArgs,
  tMutationListUpdatedArgs,
} from "./types";

export const ClientBoardsMutationHandler = {
  clientAdded(args: tMutationClientAddedArgs) {
    Cache.addClient(args);
  },
  clientRemoved(args: tMutationClientRemovedArgs) {
    Cache.removeClient(args);
  },
  listMoved(args: tMutationListMovedArgs) {
    Cache.moveList(args);
  },
  listCreated(args: tMutationListCreatedArgs) {
    Cache.addList(args);
  },
  listUpdated(args: tMutationListUpdatedArgs) {
    Cache.updateList(args);
  },
  listRemoved(args: tMutationListRemovedArgs) {
    Cache.removeList(args);
  },
  clientMoved(args: tMutationClientMovedArgs) {
    Cache.replaceClients(args);
  },
};
